import { useState, useEffect } from 'react';

import { fetchTransferOrganizations } from '~services/api.helpers';
import { useToast } from '~features/toast';

// Organizations must be fetched on a per-form basis
const useOrganizationOptions = ({ formId }) => {
  const toast = useToast();
  const [organizationOptions, setOrganizationOptions] = useState([]);

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const organizations = await fetchTransferOrganizations(formId || null);

        const options = organizations.map(organization => ({
          value: organization.id,
          label: organization.name,
        }));
        setOrganizationOptions(options);
      } catch (error) {
        console.error('Error in fetching organization options', error);
        toast.error('Yksiköiden haku epäonnistui');
      }
    };

    fetchOrganizations();
  }, []);

  return organizationOptions;
};

export default useOrganizationOptions;
